module.exports = __webpack_public_path__ + "img/block-blue.3b0fe5a5.png";